<template>
  <div class="inputSelectWrap">
    <el-input v-model="amount" :disabled="disabled" v-positivePoint2 :placeholder="placeholder || $t('common.placeholder.Amount')">
      <el-select v-model="currency" :disabled="disabled" slot="prepend">
        <el-option v-for="item in globalFormatList('currencyList')" :key="item.label" :value="item.value" :label="item.label"></el-option>
      </el-select>
    </el-input>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "CurrencyAmount",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    /** 金额输入框占位文案，默认沿用原来的通用文案 */
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currency: "",
      amount: "",
      isFirstLoad: true, //增加一个标记位，记录是否已经完成过初始化
    };
  },
  computed: {
    ...mapState("constant", ["currencyList"]),
    ...mapGetters("constant", ["globalFormatList"]),
    // 关键逻辑：将内部的两个字段合并为一个符合要求的字符串
    combinedValue() {
      if (this.currency && this.amount) return this.currency + " " + this.amount;
      if (this.amount) return " " + this.amount; // 有金额没货币，在前面加一个空格
      if (this.currency) return this.currency + " "; // 有货币没金额，在后面加一个空格
      return "";
    },
  },
  watch: {
    // 【回显】监听外部传入的 value 变化
    value: {
      handler(newVal) {
        if (newVal) {
          if (newVal.includes(" ")) {
            const parts = newVal.split(" ");
            this.currency = parts[0] || "";
            this.amount = parts[1] || "";
          } else {
            // 如果传入的数据没有空格，说明传值错误，直接重置为空
            this.currency = "";
            this.amount = "";
          }
        } else {
          if (this.isFirstLoad) {
            // 如果回显时为空，货币默认选中第一个
            const defaultFirstOne = this.currencyList[0]?.value || "";
            this.currency = defaultFirstOne;
            this.amount = "";
          } else {
            this.currency = "";
            this.amount = "";
          }
        }
        // 防止后续清空时再次触发
        this.isFirstLoad = false;
      },
      immediate: true, // 组件创建时立即执行一次
    },
    // 【触发同步】当合并后的值变化时，通知父组件更新 v-model
    combinedValue(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.inputSelectWrap {
  width: 100%;

  ::v-deep {
    .el-input {
      width: 100% !important;

      .el-input-group__prepend {
        width: 58px !important;
        padding: 0 18px 0 6px;
        background-color: #fff;
      }

      .el-input__prefix {
        color: #909399 !important;
      }

      .el-input__suffix {
        right: -14px;
      }
    }
  }
}
</style>
